import { useCallback } from 'react';
import { Result, useToasts } from '@synqo/frontend-component-library';

interface NotifyFailedRequest {
    title: string;
    message: string;
}

export const useNotifyFailedRequest = (props: NotifyFailedRequest) => {
    const { pushToast, pushAllToasts } = useToasts();

    const { message, title } = props;
    const notifyFailedRequest = useCallback(
        (failedResult: Result<unknown>) => {
            pushToast({
                title,
                message,
                variant: 'error',
            });
            pushAllToasts(failedResult.messages);
        },
        [message, pushToast, pushAllToasts, title],
    );

    return {
        notifyFailedRequest,
    };
};
